module.exports = __webpack_public_path__ + "img/chrome-step-3.d5e0b7c7.png";